interface GetThemeSettingsProps {
  themeSettings?: {
    asset?: {
      key?: string;
      public_url?: string | null;
      value?: any;
      created_at?: string;
      updated_at?: string;
      content_type?: string;
      size?: number;
      checksum?: string;
      theme_id?: number;
    };
  };
  section?: string;
}

const getThemeSettings = (themeSettings, section): GetThemeSettingsProps => {
  let content = {};
  let parsedData = themeSettings.asset.value;
  parsedData = JSON.parse(parsedData);
  const sections = parsedData?.current?.sections;
  content = sections && sections[section]?.settings;
  return content;
};

export default getThemeSettings;
